module.exports = __webpack_public_path__ + "fonts/FiraGO-Italic.b5adf36c.otf";